export default __webpack_public_path__ + "static/media/bussinesplanen.d930820f.pdf";